import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Location } from "../../../@types/location";
import axiosInstance from "../../../utils/axiosConfig";
export const createLocation = createAsyncThunk(
  "locations/create",
  async (formData: Location, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`${api.baseURL}location`, formData);
      return data as Location;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
